import React, { Component } from 'react'
import './pageheading.scss'

class PageHeading extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		let classes = ['vbui--page-heading', this.props.classes].join(' ')
		return <div className={classes}>{this.props.children}</div>
	}
}

export default PageHeading
